import styled from 'styled-components';

export const Content = styled.div`
  padding: 30px 16px;
  background: ${({ theme }) => theme.rule.background};
  min-height: 100%;
`;

export const Title = styled.h2`
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 30px;
  color: ${({ theme }) => theme.group.section.title};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 1.4em;
`;

export const SubTitle = styled.h3`
  color: ${({ theme }) => theme.group.subTitle};
  font-size: 20px;
  letter-spacing: -0.1px;
  font-weight: 600;
  margin: 30px 0;
`;

export const ButtonContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column-reverse;
  padding: 16px;
  margin-top: 30px;
`;
